export const LearningPlanStatusEnum = {
  Open: 'Openstaand',
  Pending: 'Actief',
  Completed: 'Afgerond',
} as const;
